(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["static-header"]) return;
  try {
    
$(window).scroll(function (event) {
	
    var scroll = $(window).scrollTop();

    if(scroll>0){
	$('header').addClass('customSticky');
	}else{

		$('header').removeClass('customSticky');
	}
});

  } catch(e) { console.error(e); }
})();
})();
